import _extends from "@babel/runtime/helpers/extends";
import React, { useRef, useState } from 'react';
import { Search, Text, Box, Checkbox, Radio } from '@wix/design-system';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import s from './AutocompleteWidget.module.scss';
import { generateId } from '../shared/utils';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
import { Picture } from '../shared/Picture/Picture';
export const AutocompleteWidget = _ref => {
  var _data$options, _data$secondaryButton, _data$primaryButton;
  let {
    data,
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const widgetId = useRef(generateId());
  const [search, setSearch] = useState('');
  const [selectedValues, setSelectedValues] = useState([]);
  const selectedTitles = (data.options ?? []).filter(_ref2 => {
    let {
      value
    } = _ref2;
    return selectedValues.includes(value);
  }).map(_ref3 => {
    let {
      title
    } = _ref3;
    return title ?? '';
  });
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(AUTOCOMPLETE_WIDGET, onWidgetActionData, data.text);
    };
    return handler;
  };
  const handleCheckboxClick = (value, label) => {
    let shouldAdd;
    setSelectedValues(prev => {
      shouldAdd = !prev.includes(value);
      return shouldAdd ? [...prev, value] : prev.filter(v => v !== value);
    });
    const onWidgetActionData = {
      action: shouldAdd ? 'checkbox_select' : 'checkbox_unselect',
      value: {
        value,
        label
      }
    };
    context.onWidgetAction(AUTOCOMPLETE_WIDGET, onWidgetActionData, data.text);
  };
  const handleRadioClick = (value, label) => {
    setSelectedValues([value]);
    const onWidgetActionData = {
      action: 'radio_button_select',
      value: {
        value,
        label
      }
    };
    context.onWidgetAction(AUTOCOMPLETE_WIDGET, onWidgetActionData, data.text);
  };
  const withSearch = data.options && ((_data$options = data.options) == null ? void 0 : _data$options.length) > 4;
  const filteredOptions = (data.options ?? []).filter(_ref4 => {
    let {
      title,
      subtitle,
      value
    } = _ref4;
    return [title, subtitle, value].map(text => text == null ? void 0 : text.toLowerCase()).some(text => text == null ? void 0 : text.includes(search.toLowerCase()));
  }).map(_ref5 => {
    let {
      title,
      subtitle,
      value,
      picture
    } = _ref5;
    const imageMaxWidth = '40px';
    const imageStyles = {
      maxWidth: imageMaxWidth,
      width: (picture == null ? void 0 : picture.fit) === 'original' ? 'auto' : imageMaxWidth
    };
    const optionContent = /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      verticalAlign: "middle",
      gap: "SP2"
    }, picture && /*#__PURE__*/React.createElement("div", {
      className: s.itemPicture,
      style: imageStyles
    }, /*#__PURE__*/React.createElement(Picture, _extends({}, picture, {
      aspectRatio: "1/1"
    }))), /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      className: s.item
    }, /*#__PURE__*/React.createElement(Text, {
      size: "medium"
    }, title), /*#__PURE__*/React.createElement(Text, {
      size: "small",
      className: s.subtitle
    }, subtitle)));
    return /*#__PURE__*/React.createElement(WithDisabledControl, {
      placement: "top-start",
      isDisabled: areControlsDisabled,
      onEnable: enableControls,
      t: context.t,
      key: value
    }, /*#__PURE__*/React.createElement("div", null, data.selectionType === 'multiple' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
      id: `${widgetId.current}-${value}`,
      checked: selectedValues.includes(value),
      onChange: () => {
        handleCheckboxClick(value, title);
      },
      disabled: areControlsDisabled
    }, optionContent)) : /*#__PURE__*/React.createElement(Radio, {
      id: `${widgetId.current}-${value}`,
      checked: selectedValues.includes(value),
      onChange: () => {
        handleRadioClick(value, title);
      },
      label: optionContent,
      disabled: areControlsDisabled
    })));
  });
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    text: data.text,
    secondaryButton: data.secondaryButton,
    primaryButton: data.primaryButton,
    context: context,
    selectedValues: selectedValues,
    selectedTitles: selectedTitles,
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', (_data$secondaryButton = data.secondaryButton) == null ? void 0 : _data$secondaryButton.label),
    onPrimaryButtonClick: handleButtonClick('primary_button_click', (_data$primaryButton = data.primaryButton) == null ? void 0 : _data$primaryButton.label),
    footerButtonsAsColumn: data.footerButtonsAsColumn,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, withSearch ? /*#__PURE__*/React.createElement(Search, {
    value: search,
    onChange: e => setSearch(e.target.value),
    onClear: () => setSearch(''),
    className: s.search,
    placeholder: context.t == null ? void 0 : context.t('CommonWidget.Autocomplete.search.placeholder')
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: s.items
  }, filteredOptions)));
};
export const AUTOCOMPLETE_WIDGET = 'AUTOCOMPLETE_WIDGET';
//# sourceMappingURL=AutocompleteWidget.js.map